export class MultiProductRoutes {
  public static ROUTES = {
    Home: {
      path: 'home',
      fullPath: 'home',
    },
    Catalogs: {
      path: 'catalogs',
      fullPath: 'multiproduct/catalogs',
    },
    Products: {
      path: 'products',
      fullPath: 'multiproduct/products',
    },
    Policy: {
      path: 'policy',
      fullPath: 'multiproduct/policy',
    },
    ManagePolicies: {
      path: 'manage-policies',
      fullPath: 'multiproduct/manage-policies',
    },
    MassiveEmission: {
      path: 'manage-policies/:type',
      fullPath: 'multiproduct/manage-policies/:type',
    },
    CustomerManagement: {
      path: 'manage-customers',
      fullPath: 'multiproduct/manage-customers',
    },
    BeneficiaryManagement: {
      path: 'manage-beneficiaries',
      fullPath: 'multiproduct/manage-beneficiaries',
    },
    IntermediaryManagement: {
      path: 'manage-intermediaries',
      fullPath: 'multiproduct/manage-intermediaries',
    },
    Steps: {
      StepMainData: {
        code: 'SMD',
        path: 'steps/main-data',
        fullPath: 'multiproduct/steps/main-data',
        index: 0,
        isComplete: false,
        stepNumber: 1,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepPricing: {
        code: 'SPR',
        path: 'steps/pricing',
        fullPath: 'multiproduct/steps/pricing',
        index: 1,
        isComplete: false,
        stepNumber: 2,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      // StepOne: {
      //   code: 'S1',
      //   path: 'steps/one',
      //   fullPath: 'steps/one',
      //   index: 0,
      //   isComplete: false,
      //   stepNumber: 1,
      //   img: '/assets/img/svg/step-1-blue.svg',
      // },
      // StepTwo: {
      //   code: 'S2',
      //   path: 'steps/two',
      //   fullPath: 'steps/two',
      //   index: 1,
      //   isComplete: false,
      //   stepNumber: 2,
      //   img: '/assets/img/svg/step-1-blue.svg',
      // },
      StepThree: {
        code: 'S3',
        path: 'steps/three',
        fullPath: 'multiproduct/steps/three',
        index: 2,
        isComplete: false,
        stepNumber: 3,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepFour: {
        code: 'S4',
        path: 'steps/four',
        fullPath: 'multiproduct/steps/four',
        index: 3,
        isComplete: false,
        stepNumber: 4,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepFive: {
        code: 'S5',
        path: 'steps/five',
        fullPath: 'multiproduct/steps/five',
        index: 4,
        isComplete: false,
        stepNumber: 5,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepSix: {
        code: 'S6',
        path: 'steps/six',
        fullPath: 'multiproduct/steps/six',
        index: 5,
        isComplete: false,
        stepNumber: 6,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepSeven: {
        code: 'S7',
        path: 'steps/seven',
        fullPath: 'multiproduct/steps/seven',
        index: 6,
        isComplete: false,
        stepNumber: 7,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepEight: {
        code: 'S8',
        path: 'steps/eight',
        fullPath: 'multiproduct/steps/eight',
        index: 7,
        isComplete: false,
        stepNumber: 8,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepNine: {
        code: 'S9',
        path: 'steps/nine',
        fullPath: 'multiproduct/steps/nine',
        index: 8,
        isComplete: false,
        stepNumber: 9,
        img: '/assets/img/svg/step-1-blue.svg',
      },
      StepTen: {
        code: 'S10',
        path: 'steps/charge_document',
        fullPath: 'multiproduct/steps/charge_document',
        index: 9,
        isComplete: false,
        stepNumber: 10,
        img: '/assets/img/svg/step-1-blue.svg',
      },
    },
    ProposalsBox: {
      path: 'proposals-box',
      fullPath: 'multiproduct/proposals-box',
    },
    OperationsBox: {
      path: 'operations-box',
      fullPath: 'multiproduct/operations-box',
    },
    SubscriptionsBox: {
      path: 'subscription-box',
      fullPath: 'multiproduct/subscription-box',
    },
    ComplienceBox: {
      path: 'compliance',
      fullPath: 'multiproduct/compliance',
    },
    PolicyDetails: {
      path: 'policy-detail/:id',
      fullPath: 'multiproduct/policy-detail/:id',
    },
    CustomerCreate: {
      path: 'customer-create',
      fullPath: 'multiproduct/customer-create',
    },
    CustomerDetails: {
      path: 'customer-detail/:id',
      fullPath: 'multiproduct/customer-detail/:id',
    },
    BeneficiaryCreate: {
      path: 'beneficiary-create',
      fullPath: 'multiproduct/beneficiary-create',
    },
    BeneficiaryDetails: {
      path: 'beneficiary-detail/:id',
      fullPath: 'multiproduct/beneficiary-detail/:id',
    },
    IntermediaryDetails: {
      path: 'intermediary-detail/:id',
      fullPath: 'multiproduct/intermediary-detail/:id',
    },
    IntermediaryForm: {
      path: 'intermediary-form',
      fullPath: 'multiproduct/intermediary-form',
    },
    LaftDetail: {
      path: 'customer/laft-detail/:id',
      fullPath: 'multiproduct/customer/laft-detail/:id',
    },
    MarketingBox: {
      path: 'marketing',
      fullPath: 'multiproduct/marketing',
    },
    QuotesBox: {
      path: 'quotes',
      fullPath: 'multiproduct/quotes',
    }
  };
}
